import React from 'react';
import { useIntl } from 'react-intl';
import { Dropdown } from 'semantic-ui-react';

const DataManagementDataModelTools = ({
  disableValidate,
  name,
  showReports,
  validate,
}) => {
  const intl = useIntl();
  return (
    <>
      <Dropdown.Item
        icon="play"
        text={intl.formatMessage({ id: 'actions.validate' })}
        as="a"
        onClick={disableValidate ? undefined : () => (validate())}
        disabled={disableValidate}
      />
      <Dropdown.Item
        icon="history"
        text={intl.formatMessage({ id: 'actions.validation.reports.dictionary.row' })}
        as="a"
        onClick={disableValidate ? undefined : () => (showReports({ name }))}
        disabled={disableValidate}
      />
    </>
  );
};

export default DataManagementDataModelTools;
